export default __webpack_public_path__ + "static/media/bitdev.3e368860.webp";